define('home/views/DiscussionCreateToolbarView',[
    'backbone-marionette',

    'core/views/media/UploadButtonView',

    'home/mixins/withSubviews',
    'home/utils/confirmModal',
    'home/views/formatting/FormattingButtonsView',

    'home/templates/discussionCreateToolbar',
    'home/templates/formatting',
    'home/templates/uploadButton',
], function (
    Marionette,

    UploadButtonView,

    withSubviews,
    confirmModal,
    FormattingButtonsView,

    discussionCreateToolbarTemplate,
    formattingTemplate,
    uploadButtonTemplate
) {
    'use strict';

    var parent = Marionette.ItemView;
    var parentProto = parent.prototype;

    // This class provides UI elements for actions which may be
    // applied to the postbox in the discussion create form,
    // including uploads and formatting.
    var DiscussionCreateToolbarView = parent.extend({
        template: discussionCreateToolbarTemplate,

        events: {
            'click [data-action=show-formatting]': 'showFormatting',
        },

        regions: {
            formattingButtonsRegion: '[data-role=formatting-buttons]',
            uploadButtonRegion: '[data-role=upload-button]',
        },

        initialize: function (options) {
            // Accepts an accessor function to retrieve the postbox view.
            // This is done via a function to avoid being tied to a
            // particular rendering approach in the parent views.
            this.getPostbox = options.getPostbox;
        },

        render: function () {
            parentProto.render.call(this);

            this.activateRegion(this.uploadButtonRegion, this.createUploadButton);
            this.activateRegion(this.formattingButtonsRegion, this.createFormattingButtons);

            return this;
        },

        createUploadButton: function () {
            var view = new UploadButtonView({
                el: this.uploadButtonRegion.el,
                template: uploadButtonTemplate,
            });

            // Hook event to postbox's upload callback
            this.listenTo(view, 'uploader:attachMedia', function () {
                var postbox = this.getPostbox();
                postbox.handleUploadViaButton.apply(postbox, arguments);
            });

            return view;
        },

        createFormattingButtons: function () {
            return new FormattingButtonsView({
                el: this.formattingButtonsRegion.el,
                getPostbox: this.getPostbox,
            });
        },

        showFormatting: function () {
            confirmModal.confirmationPromise(
                confirmModal.TYPES.CLOSE,
                formattingTemplate(this.model.thread.forum.channel.toJSON())
            );
        },
    });

    withSubviews.call(DiscussionCreateToolbarView.prototype);

    return DiscussionCreateToolbarView;
});

